import { AttributeDefinition } from '../attributes/attributeDefinition';
import { EvaluationsQuestion } from './evaluations-question';

export class EvaluationDefinition {
  public id: string;
  public title: string;
  public introduction: string;
  public confirmation: string;
  private _questions: EvaluationsQuestion[] = [];
  public isArchived: boolean;
  public hasExpired: boolean;

  constructor() {}

  public get questions(): EvaluationsQuestion[] {
    return this._questions;
  }
  private setQuestions(value: EvaluationsQuestion[]) {
    this._questions = value.map((question) => {
      if (question) {
        return EvaluationsQuestion.parse(question);
      }
    });
  }

  private updateQuestions(updatedQuestions: EvaluationsQuestion[]) {
    //updates the existing questions
    updatedQuestions.forEach((q) => {
      let index = this._questions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index != -1) {
        this._questions[index].attributeDefinition = AttributeDefinition.parse(
          q.attributeDefinition
        );
        this._questions[index].conditions = q.conditions;
        this._questions[index].descriptionOverride = q.descriptionOverride;
        this._questions[index].isRequired = q.isRequired;
      } else {
        //adds a new questions
        this._questions.push(EvaluationsQuestion.parse(q));
      }
    });

    //removes  questions
    this._questions.forEach((q) => {
      let index = updatedQuestions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index == -1) {
        this._questions.splice(this._questions.indexOf(q), 1);
      }
    });
  }
  private setData(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.introduction = data.introduction;
    this.isArchived = data.isArchived;
    this.hasExpired = data.hasExpired;
    if (!data.confirmation) {
      this.confirmation = 'Thank you for completing the evaluation.';
    } else {
      this.confirmation = data.confirmation;
    }
  }
  public update(data: EvaluationDefinition) {
    if (!data) return null;
    this.setData(data);

    this.updateQuestions(data.questions);
    return this;
  }
  public static parse(data: any): EvaluationDefinition {
    if (!data) return null;

    let evaluation = new EvaluationDefinition();
    evaluation.setData(data);

    evaluation.setQuestions(data.questions);
    return evaluation;
  }

  public moveQuestion(oldIndex: number, newIndex: number) {
    let movedValue = this._questions.splice(oldIndex, 1);
    this._questions.splice(newIndex, 0, ...movedValue);
  }
}
